"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _antd = require("antd");
var _react = _interopRequireDefault(require("react"));
var Demo = function Demo() {
  return /*#__PURE__*/_react.default.createElement(_antd.Space, {
    direction: "vertical"
  }, /*#__PURE__*/_react.default.createElement(_antd.DatePicker._InternalPanelDoNotUseOrYouWillBeFired, {
    picker: "week"
  }), /*#__PURE__*/_react.default.createElement(_antd.DatePicker._InternalPanelDoNotUseOrYouWillBeFired, {
    picker: "month"
  }), /*#__PURE__*/_react.default.createElement(_antd.DatePicker._InternalPanelDoNotUseOrYouWillBeFired, {
    picker: "quarter"
  }), /*#__PURE__*/_react.default.createElement(_antd.DatePicker._InternalPanelDoNotUseOrYouWillBeFired, {
    picker: "year"
  }));
};
var componentDemo = {
  demo: /*#__PURE__*/_react.default.createElement(Demo, null),
  tokens: ['colorPrimary', 'colorPrimaryBorder', 'colorPrimaryHover', 'controlOutline', 'colorBgElevated', 'colorBgContainer'],
  key: 'default'
};
var _default = exports.default = componentDemo;